import { Action } from 'common/interfaces/root';
import { recommendedAsinsActionTypes as TYPES } from '../actions';

const initialState: AffiliateGainzModule.RecommendedAsinsModule.ExportStore = {
  loading: false,
  data: null,
  error: null,
};

export default (
  state: AffiliateGainzModule.RecommendedAsinsModule.ExportStore = initialState,
  { type, payload }: Action
): AffiliateGainzModule.RecommendedAsinsModule.ExportStore => {
  switch (type) {
    case TYPES.EXPORT.GET_EXPORT:
      return { ...state, loading: true };
    case TYPES.EXPORT.GET_EXPORT_SECCUESS:
      return { ...state, loading: false, data: payload };
    case TYPES.EXPORT.GET_EXPORT_ERROR:
      return { ...state, loading: false, error: payload };

    default:
      return state;
  }
};
